import { JSX } from 'react';

import { Text } from '@videoblocks/design-system';

export const UpgradeCreditPlanHeader = (): JSX.Element => {
    return (
        <div className="w-full text-center mb-4">
            <Text asChild fontSize="3xl" fontWeight="semibold" className="m-0 mb-4 font-polysans">
                <h1>Upgrade your plan. Maximize your workflow.</h1>
            </Text>
            <Text fontSize="base" fontWeight="regular" className="m-0 font-polysans">
                Charged amount will be prorated according to your current plan so you won’t have to pay extra.
            </Text>
        </div>
    );
};
